module.exports = __webpack_public_path__ + "static/media/pet-state-final.38bca8a5.svg";